module.exports = __webpack_public_path__ + "img/RO.ad9f4a33.svg";